module.exports = true;



//////////////////
// WEBPACK FOOTER
// /causemisspiggynodeweb-ci-9188/workspace/Release/~/core-js/library/modules/_library.js
// module id = 376
// module chunks = 0